import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAward, faBriefcase, faHeadphones } from '@fortawesome/free-solid-svg-icons'

export default function Info({ info }) {
  const icons = [faAward, faBriefcase, faHeadphones];

  return (
    <div className='about__info grid'>
      {info.map((item, index) => (
        <div key={index} className='about__box'>
          <FontAwesomeIcon icon={icons[index]} className='about__icon' />
          <h3 className='about__title'>{item.title}</h3>
          <span className='about__subtitle'>{item.subtitle}</span>
        </div>
      ))}
    </div>
  )
}
